import CheckroomIcon from "@mui/icons-material/Checkroom";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import { ROUTE_PATH } from "./route";


const HEADING = {
  WELCOME_BACK: "Welcome back!",
  LETS_GET_STARTED: "Let's get started",
};

const SUB_HEADING = {
  LOGIN_TO_CONTINUE_TO_ACCOUNT: "Login to continue to your account",
  CREATE_YOUR_ACCOUNT_BY_ENTERING_EMAIL:
    "Create your account by entering your email",
};

const INPUT_LABELS = {
  fullName: "Full Name",
  email: "Email",
  password: "Password",
  confirmPassword: "Confirm Password",
  name: "Name",
  age: "Age",
  newPassword: "New Password"
};

const BUTTON_LABELS = {
  LOGIN: "Login",
  SIGN_UP_GOOGLE: "Sign up with Google",
  SIGN_UP_FACEBOOK: "Sign up with Facebook",
  SIGN_UP: "Sign Up",
  FORGOT_PASSWORD: "Forgot Password",
  REMEMBER_ME: "Remember me",
  CONTINUE: "Continue",
  CREATE_ACCOUNT: "Create account",
};

const HOME_PAGE = {
  buttonLabels: {
    about: "About Us",
    howItWorks: "How It Works",
    continueAsGuest: "Continue as guest",
    login: "Login",
    signup: "Sign Up",
    browse: "Browse",
    viewAll: "View all",
    support: "Get Support",
    blog: "Read",
  },
  footer: {
    quickLinks: "Quick Links",
    wanderobe: "©2025 Wanderobe. All Rights Reserved.",
    terms: "Terms & Conditions",
    privacy: "Privacy Policy",
    termsAriaLabel: "Go to Terms & Conditions page",
    privacyAriaLabel: "Go to Privacy Policy page",
    logoAriaLabel: "Go to Landing page",
    logoAltText: "Wanderobe Logo",
    title:
      "Don't just visit the city. Wear it home.",
    instaAriaLabel: "Follow us on Instagram",
    fbAiraLabel: "Follow us on Facebook",
    twitterAriaLabel: "Follow us on Twitter",
    getInTouch: "Get in Touch",
    downloadApp: "Download App",
    downloadAppLabel:
      "Download the app",
  },
  ariaLabels: {
    goToAbout: "Go to About us page",
    goToHowItWorks: "Go to How it works page",
    goToSupport: "Go to Support page",
    openBag: "Open Bag",
    goToCloset: "Go to Closet page",
    goToMyProfile: "Go to profile",
    goToBrowseMore: "Go to Browse more page",
    login: "Go to Login page",
    signup: "Go to Sign up page",
    navigateToLanding: "Navigate to Landing page",
    search: "Search by designer",
    howItWorks: "Go to How it works section",
    customerSupport: "Go to Customer support form",
    showNavigation: "Show Navigation bar",
    viewProfile: "View profile",
    open_close: "Open/Close Section",
    exploreCollections: "Explore all collections",
    viewAllCollecstions: "View all collections",
    scrollPrevious: "Scroll to previous products",
    scrollNext: "Scroll to next products",
  },
  placeholders: {
    search: "Search by designer",
    logo: "Wanderobe Logo",
  },
  messages: {
    newUser: "New user?",
    createAccount: "Create Your Wanderobe Account",
    joinPrompt:
      "Join to explore the world of designer fashion at your travel destination",
  },
  drawerText: {
    customerSupport: "Customer Support",
    browse:"Browse",
    bag: "Bag",
    myCloset: "Closet",
    profile: "Profile",
  },
  searchBar: {
    selectCity: "Select City",
    selectHotel: "Select Hotel",
    arrivalDate: "Arrival Date",
    arrivalDate1: "Select Arrival date",
    explore: "Create trip",
  },
};

const HOW_IT_WORKS_STEP = [
  {
    sn: "01",
    title: "Choose Your Hotel",
    description: "Select a hotel where you have an upcoming reservation and choose your arrival date.",
  },
  {
    sn: "02",
    title: "Shop The Destination",
    description:
      "Browse our curated collections of apparel and accessories. Add your picks to your bag and confirm your order.",
  },
  {
    sn: "03",
    title: "Try On Your Styles",
    description: "Your selected styles await your arrival. Use your hotel room as your personal fitting room for 48 hours.",
  },
  {
    sn: "04",
    title: "Keep What You Love",
    description:
      "After two days, we'll collect any returns and charge you only for what you keep.",
  },
];
const HOW_IT_WORKS_INFO = [
  {
    title: "Payment Process",
    description: "Confirm your order with a Reservation Fee. After your 2-day trial, you will be charged the retail price of the pieces you keep. You will not be charged for any pieces you decide to return within the trial window.",
  },
  {
    title: "What to Expect Upon Arrival",
    description: "Your wardrobe will be in your room or delivered by hotel staff shortly after check-in.",
  },
  {
    title: "The Fitting Experience",
    description: `Take time to try on your new fashion finds from NYC designers. Leave the tag on anything you’re not planning to purchase –Wanderobe will only accept returns with the tags intact. Use the "My Closet" section of the app to confirm.`,
  },
  {
    title: "How We Handle Returns",
    description: "Place return pieces (with tags) in the garment bag provided and leave them at the front desk. The bag is yours to keep if you're not returning anything",
  },
  {
    title: "Sales Are Final",
    description: "You'll be charged automatically for any pieces not returned within 48 hours. After that, all sales are considered final.",
  },
];
const PROFILE_PAGE = {
  heading: "Create Profile",
  subheading: "Set up your profile to personalize your experience",
  skip:"Skip for now",
  nameLabel: "Name*",
  ageLabel: "Age",
  locationLabel: "Your location",
  clothingPreference: "Select clothing preference",
  sizeLabel: "Sizes",
  hideSize: "Hide my size from reviews",
  mobileNumber: "Mobile number*",
  enterYourName: "Enter your name",
  enterYourAge: "Enter your age",
  enterYourLocation: "Add your location",
  enterYourSize:"Select your Size",
  enterYourNumber: "Enter your number",
  doneButton: "Done",
  changeProfile:"Change Profile",
  RemoveProfile:"Remove Profile",
};


const SOCIALMEDIA_URL = {
  facebook: "https://www.facebook.com/profile.php?id=61575244167877",
  instagram: "https://www.instagram.com/wanderobe.co/",
  twitter: "https://www.x.com/",
  appleStore: {
    alt: "App Store",
    url: "https://apps.apple.com/us/app/wanderobe/id6740470599",
    ariaLabel: "Download from App Store",
  },
  playStore: {
    alt: "Google Play",
    url: "https://play.google.com/store/apps/details?id=com.wanderobe_mobile",
    ariaLabel: "Download from Google Play",
  },
};

const SOCIAL_LOGIN_API = {
  facebook: "https://connect.facebook.net/en_US/sdk.js",
  apple: "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js",
};

const PRODUCT_LIST = {
  viewAll: "View more",
  products: "Products",
  designer: "Designers",
  areaLabel: {
    designerPage: "Go to Designer page",
    clear: "Clear Input",
    tab: "Filter by alphabet",
    search: "Search by category",
    clearData: "Clear recent search data"
  },
  placeholders: {
    search: "Search by designer, piece, keyword",
  },
  recentSearch: "Recent searches",
  clear: "Clear all",
  viewAllBtn: "View all"
}
const SHOPPING_CART_MODAL = {
  headings: {
    addToBag: "Add to Bag",
    createTrip: "Create new trip",
    selectYourSize: "Select your size",
    selectYourTrip: "Select your trip",
    selectedSize:"SIZE:",
    replacetitle:"Replace existing trip?",
    addcity:"Add city",
    addArrivalDate:"Add arrival date?",
    addHotel:"Add hotel"
  },
  messages: {
    addTripDetails: "Add your next trip details to fill your bag and buy the product accordingly.",
    createNewTrip: "Create new trip",
    selectNewTrip: "Select new hotel, city, and arrival date",
    alertMessage: "Please select city, hotel, and date.",
    replacedescription1: "Your existing trip contains details ",
    replacedescription2: " and already has ",
    replacedescription4: " items added",
    replacedescription3: ". Do you want to discard the selected trip and create a new one?"
},
  buttons: {
    createTrip: "Create trip",
    updateTrip: "Update trip",
    addToBag: "Add to Bag",
    cancel:"Cancel",
    replace:"Replace",
    yes: "Yes",
  },
  productDetails: {
    brand: "Saint Laurent",
    productName: "Double Breasted Blazer",
    price: "$49.99",
  },
  placeholders: {
    selectCity: "Select City",
    selectHotel: "Select Hotel",
    selectArrivalDate: "Select Arrival Date",
  },
}

const PRODUCT_DETAILS = {
  altTags : {
    productImage: "Product Image",
    favourite_icon: "Mark Favourite",
    remove_favourite_icon: "Unmark Favourite",
    open_close_accordian: "Open/Close Accordian",
  },
  other_items_designer: "Other pieces from designer",
  view_reviews: "View All Reviews",
  size: "Size:",
  read_less: " Read Less",
  read_more: " Read More",
  reviews_ratings: "Reviews & ratings",
  reviews: "reviews",
  colors: "Colors:",
  to_favourites: "to favorites",
  added: "Added",
  add: "Add",
  remove_favourite: "Remove from favourite",
  add_bag: "Add to bag",
  product_description: "Product description",
  about_designer: "About the Designer",
  out_of_stock: "Out of stock",
}




const CURRENCY = {
  DOLLAR: "$"
}

const EMPTY_BAG = {
  title: "Bag",
  emptyMessage: "Your bag is empty",
  shopButton: "Shop now"
};

const PRODUCT_DATA = {
  hotelName: "Hotel Shangri-La Santa Monica",
  city: "San Francisco",
  arrivalText: "Arrival date",
  arrivalDate: "02 Feb 2025",
  itemsAdded: " piece(s) added",
  viewItems: "View piece(s)"
};

const CREATE_NEW_TRIP = {
  heading: "Create new trip",
  subheading: "Select new hotel, city, and arrival date"
};
const TRIP_DETAILS = {
  title: "Trip details",
  subtitle: "Deliver to",
  recipientName: "Cameron Williamson",
  hotelName: "Hotel Shangri-La Santa Monica",
  location: "San Francisco",
  arrivalText: "Arrival date",
  arrivalDate: "02 Feb 2025",
  itemsAdded: " piece(s) added"
};
const SAMPLE_ITEMS = [
  {
    image: "https://via.placeholder.com/80",
    designer: "Ralph Lauren",
    product: "Double Breasted Blazer",
    color: "Beige",
    colorHex: "#f5f5dc",
    price: 80.0,
  },
  {
    image: "https://via.placeholder.com/80",
    designer: "Saint Laurent",
    product: "Double Breasted Blazer",
    color: "Brown",
    colorHex: "#8B4513",
    price: 80.0,
  },
];

  const TOTAL_BOX = {
    title: "Amount details",
    subtitle: "Subtotal",
    Tamount:"$160.00",
    title2:"Reservation Fee",
    title3:"Amount Due Now",
    amount1:"$9.99",
    button:"Proceed to checkout",
  };

  const CHECKOUT_BOX = {
    title: "Checkout",
    estimated_delivery: "Estimated delivery on",
    delivery_date: "5 Jan 25",
    amount_title: "Amount due now",
    amount_value:"$9.99",
    amount_description:
      "Reservation Fee only. Retail price of kept pieces will be charged after the trial period.",
    policy_title: "Return policy",
    checkout_title:"Keep or Return policy",
    checkout_desc:"Read all the guidelines to know about the process.",
    policy_description: "Read the guidelines to get the most out of your Wanderobe experience.",
    policies: [
      "Try on your wardrobe after you check in to your hotel. Do not wear any piece out of your hotel room unless you purchase it.",
      "After 48 hours, return any unwanted pieces to the hotel front desk in the garment bag provided, and indicate in the app which pieces you are keeping/returning.",
      "Any pieces not returned will automatically be charged for purchase after 48 hours. Sales are final.",
    ],
    
    view_policies_button: "View all policies",
    view_less_button: "View less policies",
    checkbox_text: "I have read and understand the trial and return instructions.",
    name_title: "Name confirmation",
    name_description:
      "Please confirm your name. It will be registered during the hotel booking process.",
    name_confirmation_question:
      "Is your name the same as entered during booking?",
    new_name:"Add new name",
    confirmation_message:"Name same as hotel booking name",
    name_default: "Cameron",
    no_button: "No",
    yes_button: "Yes",
    confirm_button: "Save & Continue",
    custom_button_label:"Confirm Checkout",
    terms_condition_label:"Accept terms and conditions",

    };

  const CLOSET ={
    heading:"My Closet",
    subHeading:"Track and Manage Your Selections",
    trip: "trip",
    tabLabels : ["Current", "Planned", "Past", "Favorites"],
    cancelButton: "Cancel order", 
     ReturnModal: {
      title: "Return piece?",
      description: "Are you sure you want to return this piece?",
    },
    Buttons : {
     RETURN: "Return",
     CANCEL: "Cancel",
    }  ,
    tabContent : {
        Current: {
          icon: <CheckroomIcon className="nodata-icon" />,
          title: "No current trip",
          //subtitle: "You have no current trip to show into your closet.",
          buttonText: "View planned trip",
          link: `${ROUTE_PATH.CLOSET}?tab=Planned`,
        },
        Planned: {
          icon: <CheckroomIcon className="nodata-icon" />,
          title: "No planned trips found",
          subtitle: "Start planning your next adventure!",
          buttonText: "Shop now",
          link: ROUTE_PATH.BROWSE
        },
        Past: {
          icon: <CheckroomIcon className="nodata-icon" />,
          title: "No past trips",
          //subtitle: "You have no past trip to show into your closet.",
          buttonText: "View planned trip",
          link: `${ROUTE_PATH.CLOSET}?tab=Planned`
        },
        Favorites: {
          icon: <ShoppingBagOutlinedIcon className="nodata-icon" />,
          title: "Your favorites list is empty",
          subtitle: "Start adding your favorite items for quick access.",
          buttonText: "Explore now",
          link: ROUTE_PATH.BROWSE
        },
      }
    }

    const CANCELLATION_POLICIES ={ 
      title:"Cancellation policy",
      subtitle:"The order can be canceled based on the following policies, and the reservation fee will be refundable.",
      heading : ["Cancellation time", "Cancellation charges"],
      data:[
      { time: "7+ days before check-in", charge: "Full refund", tooltip: "Of the Wanderobe Reservation Fee." },
      { time: "1-6 days before check-in", charge: "50% refund", tooltip: null },
      { time: "Within 24 hrs of check-in", charge: "Non-refundable", tooltip: null }
  ]}

  const FAQ_CONSTANTS = {
    HELP_TITLE: "HELP & SUPPORT",
    SUPPORT_TEXT:
      "From setting up your account to growing your business, our dedicated support team is here to help.",
    BUTTON_LABEL: "Contact Support",
    FAQ_TITLE: "FAQ’s",
    SECTION_TITLE: "Here to Support You Every Step of the Way",
    accordions: [
      {
        id: "panel1",
        title: "How do I sell my clothes through Wanderobe?",
        content:
          "Apply through the Wanderobe website. We’ll review your portfolio and reach out if we think your brand is a good fit for our audience. Approved Sellers will be invited to set up their profiles through the Platform."
      },
      {
        id: "panel2",
        title: "Who are Wanderobe's buyers?",
        content:
          "Our customers are stylish explorers and frequent travelers who value quality, craftsmanship, and cultural authenticity.",
      },
      {
        id: "panel3",
        title: "What are the benefits of joining Wanderobe?",
        content:
          "Wanderobe is built to support and uplift emerging, independent designers. As a partner designer, you’ll gain access to a highly targeted audience, tools to showcase your collections, and the opportunity to participate in exclusive promotional events.",
      },
      {
        id: "panel4",
        title: "How much does it cost to join Wanderobe?",
        content:
          "There are no fees to join Wanderobe as a Seller. We charge a small commission on each sale made through the platform.",
      },
      {
        id: "panel5",
        title: "How does Wanderobe handle payments?",
        content:
          "We process all payments securely and transfer funds to your account on a regular schedule. You’ll also have access to detailed sales analytics.",
      },
      {
        id: "panel6",
        title: "Can I set my own return policy?",
        content:
          "Wanderobe has a standard return policy built into the service model. We give customers 2 days to try the items (using their hotel room as the fitting room) and decide what they want to keep. Any items kept past the trial period, or worn outside of the hotel room, are charged as a non-refundable purchase. Any items they elect not to keep after the 2 day trial will be returned to you in as-new condition.",
      },
      {
        id: "panel7",
        title: "How do I fulfill orders through Wanderobe?",
        content:
          "Sellers are notified in realtime as orders are placed and will be expected to promptly fulfill the orders. All orders are drop shipped directly to Wanderobe HQ in Brooklyn, New York for processing. There is also the option of a consignment model, in which some inventory is housed at Wanderobe HQ to facilitate seamless, on-demand processing. Wanderobe takes a smaller commision from designers selling through the consignment model.",
      },
      {
        id: "panel8",
        title: "How do I set up my inventory?",
        content:
          "Wanderobe's seller platform includes user-friendly inventory management. You will be required to invest a bit of time upfront to upload your inventory, which will update dynamically as orders are processed.  ",
      },
    ],
  };
  const FAQ_CONSTANTS_MAIN = {
    maintitle:"We’re Here to Help",
    title:"Getting started",
    subtitle:"Step-by-step instruction",
    boxplaceholder:"Search topics",
    FAQtitle:"FAQ’s",
    FAQsubtitle:"Get quick answers to common questions.",
    contactTitle:"Contact Us",
    contactPhone:"Phone",
    contactEmail:"Email",
    contactpara:"Available Monday to Friday 8:00 AM to 9:00 PM EST.",
  };
 
export {
  HEADING,
  SUB_HEADING,
  BUTTON_LABELS,
  INPUT_LABELS,
  HOME_PAGE,
  HOW_IT_WORKS_STEP,
  HOW_IT_WORKS_INFO,
  SOCIALMEDIA_URL,
  SOCIAL_LOGIN_API,
  PROFILE_PAGE,
  PRODUCT_LIST,
  PRODUCT_DETAILS,
  SHOPPING_CART_MODAL,
  EMPTY_BAG,
  PRODUCT_DATA,
  CREATE_NEW_TRIP,
  TRIP_DETAILS,
  SAMPLE_ITEMS,
  CURRENCY,
  TOTAL_BOX,
  CHECKOUT_BOX,
  CLOSET,
  CANCELLATION_POLICIES,
  FAQ_CONSTANTS,
  FAQ_CONSTANTS_MAIN
};
